import React from 'react';
import PropTypes from 'prop-types';
import './modal.scss';

const Backdrop = ({ closeModal, children, backdropClass }) => {
    const className = backdropClass || "backdrop";

    return (
        <div className={className} onClick={closeModal}>
            {children}
        </div>
    );
};

Backdrop.propTypes = {
    closeModal: PropTypes.func,
    backdropClass: PropTypes.string
};

export { Backdrop };